import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, History } from 'lucide-react';
import { MOCK_REQUESTS } from '../utils/mockData';
import { RequestCard } from './RequestCard';
import { Button } from './ui/Button';
export function RequestHistory() {
  const navigate = useNavigate();
  const recentRequests = MOCK_REQUESTS.slice(0, 3);
  if (recentRequests.length === 0) return null;
  return <div className="mt-10 mb-8" data-id="element-93">
      <div className="flex items-center justify-between mb-4 px-1" data-id="element-94">
        <div className="flex items-center gap-2" data-id="element-95">
          <History className="w-5 h-5 text-teal-600" data-id="element-96" />
          <h3 className="text-lg font-bold text-gray-900" data-id="element-97">Recent Requests</h3>
        </div>
        <button onClick={() => navigate('/history')} className="text-sm font-medium text-teal-600 hover:text-teal-700 flex items-center gap-1 transition-colors" data-id="element-98">
          View All <ArrowRight className="w-4 h-4" data-id="element-99" />
        </button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-100">
        {recentRequests.map(request => <RequestCard key={request.id} request={request} data-id="element-101" />)}
      </div>

      <div className="mt-6 text-center sm:hidden" data-id="element-102">
        <Button variant="outline" fullWidth onClick={() => navigate('/history')} className="text-sm" data-id="element-103">
          View All History
        </Button>
      </div>
    </div>;
}